import React from 'react'
import { StyleSheet } from 'react-native'
import { SectionHeader, ResponsiveContainer } from '../../../components'
import { colors } from '../../../functions'

const s = StyleSheet.create({
  sectionContainer: {
    backgroundColor: colors.primary2,
    borderRadius: 20,
    marginBottom: 24,
    paddingHorizontal: 20,
  },
  sectionContainerMobile: {
    backgroundColor: colors.primary2,
    borderRadius: 20,
    marginBottom: 24,
    paddingLeft: 10,
    paddingRight: 10,
  },
})

export const Section = ({
  title,
  component,
  events,
  eventCount,
  status,
  venueId,
  queryDate,
  scrollable,
  customLink,
}) => (
  <ResponsiveContainer
    style={s.sectionContainer}
    breakpoint={434} // 414 + 10 px padding on each side
    breakpointStyle={s.sectionContainerMobile}
  >
    <SectionHeader title={title} customLink={customLink} />
    {component(events, status, venueId, queryDate, scrollable)}
  </ResponsiveContainer>
)
